/**
 * JSON Schema Scalar extensions.
 *
 * Applied on OpenAPI `components.schemas` or inline schema objects. Covers enum metadata,
 * examples, variables, and additional property naming.
 */
export { XAdditionalPropertiesName } from './x-additional-properties-name.js';
export { XEnumDescriptions } from './x-enum-descriptions.js';
export { XEnumVarNames } from './x-enum-varnames.js';
export { XExamples } from './x-examples.js';
export { XVariable } from './x-variable.js';
